import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ShowVisibleNextGroup } from '../actions'

const mapStateToProps = (state) => {
     return {
        DisplayNextGroup:state.displaynextgroup,
     };
     
   }

const mapDispatchToProps = dispatch => ({
    ShowVisibleNextGroupIn: (post,temp) => {
      dispatch(ShowVisibleNextGroup(post,temp))
    },
  })

 class GroupsSlim extends Component {
        constructor(props) {
            super(props);
            this.state = {visible: ' active'};
        }

    ShowVisible(){
        this.props.ShowVisibleNextGroupIn(true,true);
    }

render(){
    const { DisplayNextGroup } = this.props;

    if(DisplayNextGroup.length != 0){
        if(DisplayNextGroup.displaynextgroup === true || DisplayNextGroup.displaynextgroup === 'ocultar'){
        this.state.visible = '';
        }else if(DisplayNextGroup.displaynextgroup === false){
        this.state.visible = ' active';
        }else{
        this.state.visible = ' active';    
        }
    }

    return(
       
       <div className={'monitoria--slim w-5'+this.state.visible} onClick={event => this.ShowVisible(event)}>
            <span className="monitoria--slim__tool-tip tool-tip">Exibir</span>
            <span className="monitoria--slim__icon material-icons">arrow_forward</span>
            <p className="monitoria--slim__text is-poppins is-poppins--bold">Monitorar</p>
        </div>
    
        
    )}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(GroupsSlim);